// extracted by mini-css-extract-plugin
export var dateLabel = "_3a-0";
export var dateLabelError = "_3a-1";
export var fullWidth = "_3a-2";
export var smaller = "_3a-3";